export default function DescriptionCard({ image, description }) {
  return (
    <div className="bg-gradient-to-b from-rose-50 to-amber-50 text-black p-4 rounded-xl shadow-sm border ">
      <img src={image} alt={description} className="rounded-lg mb-2" />
      <p className="text-md font-medium">{description}</p>
    </div>
  );
}